export const GLOBAL_GROUP_KEY = 'global'
